import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ThreatAssessmentInfo = {
  id: number | null;
  title: string;
};

type ThreatAssessmentStateType = {
  selectedEntityThreatAssessmentInfo: ThreatAssessmentInfo;
};

export const INITAL_THREAT_ASSESSMENT_STATE: ThreatAssessmentStateType = {
  selectedEntityThreatAssessmentInfo: { id: null, title: '' },
};

const ThreatAssessmentSlice = createSlice({
  name: 'threat-assessment',
  initialState: INITAL_THREAT_ASSESSMENT_STATE,
  reducers: {
    setSelectedEntityThreatAssessmentInfo: (
      state,
      action: PayloadAction<ThreatAssessmentInfo>
    ) => {
      state.selectedEntityThreatAssessmentInfo.id = action.payload.id;
      state.selectedEntityThreatAssessmentInfo.title = action.payload.title;
    },
  },
});

export const { setSelectedEntityThreatAssessmentInfo } =
  ThreatAssessmentSlice.actions;

export default ThreatAssessmentSlice.reducer;
